var path = '/templates/zenclerk_s/sites/campaigns/list/campaigns_list.html';
var html = "<div class=\"row campaigns-empty\" ng-if=\"$ctrl.pagedCampaigns.length == 0\"><div class=col-sm-12><p>{{ 'sites.campaigns.list.campaignsList.campaignNotAvailable' | translate }}</p></div></div><zcs-campaigns-list-item ng-repeat=\"campaign in $ctrl.pagedCampaigns\" project=$ctrl.project campaign=campaign filters=$ctrl.filters show-stats=$ctrl.showStats on-update=onUpdate() on-remove=removeCampaign(campaign)></zcs-campaigns-list-item><zcs-notification-timezone project=$ctrl.project></zcs-notification-timezone>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/list/campaigns_list.html
// module id = 1398
// module chunks = 0